var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSecurityBlueInverse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.191 0l-9.791 4.363v6.546c0 6.054 4.177 11.717 9.791 13.091 5.614-1.374 9.791-7.037 9.791-13.091v-6.546zM12.191 11.989h7.615c-0.486 4.509-3.476 8.214-7.535 9.726l-0.081 0.026v-9.742h-7.615v-6.218l7.615-3.392v9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009af6",
    d: "M12.178 2.398v9.608l7.621 0.012v-6.442z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSecurityBlueInverse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/security-blue-inverse.e5716602.svg";
export { ForwardRef as ReactComponent };